import { useEffect, useState } from "react";

import { GenericTooltip } from "@components/tooltip-container";
import { Checkbox } from "@shared/checkbox";
import { Modal } from "@shared/modal";

export interface EditSettingsModalProps {
  isOpen: boolean;
  onClose: () => void;
  readonly shopUrl: string;
  readonly updateCollectPageViews: (
    collectPageViews: boolean,
  ) => Promise<void> | void;
  readonly collectPageViews: boolean;
}

export const EditSettingsModal = ({
  shopUrl,
  updateCollectPageViews,
  ...props
}: EditSettingsModalProps) => {
  const [collectPageViews, setCollectPageViews] = useState(
    props.collectPageViews,
  );

  useEffect(() => {
    setCollectPageViews(props.collectPageViews);
  }, [props.isOpen, props.collectPageViews]);

  const tooltipText =
    "This setting configures the web pixel to track page view events and should be selected if there is no other pixel available for this shop.";

  return (
    <Modal
      isOpen={props.isOpen}
      onClose={props.onClose}
      titleContent={<div className="font-bold text-xl">Shopify Settings</div>}
    >
      <p className="font-bold">{shopUrl}</p>
      <div>
        <Checkbox
          value={collectPageViews}
          onChange={async (collectPageViews: boolean) => {
            setCollectPageViews(collectPageViews);
            await updateCollectPageViews(collectPageViews);
          }}
          label="Enable page view event tracking"
        ></Checkbox>
        <GenericTooltip content={tooltipText}></GenericTooltip>
      </div>
    </Modal>
  );
};
